<template>
  <section class="think-area responsive-content area-padding no-bottom-padding">
    <div class="think-fluid">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="avivon-heading">
              <h3 class="avivon__title">
                Para iluminar a México hay que trabajar en conjunto.
              </h3>
              <p class="avivon__desc offer-title2 mt-40px mb-35px">
                El equipo de RedGirasol, junto con toda nuestra red, trabajamos
                arduamente para llevar energía limpia a todo el país. Debido a esto,
                la operación se sustenta a través de ciertas comisiones que pedimos
                a los integrantes de la Red, según sea el caso. <br>
                <span class="bold rg-black">¡Juntos creamos el mejor crédito solar de México!</span>
              </p>
            </div><!-- end avivon-heading -->
          </div><!-- end col-md-6 -->
          <div class="col-md-6 img-no-full">
            <div class="think-column-box clearfix">
              <img class="rounded d-block rg-img custom-img" :src="img1" alt="rg">
            </div><!-- end think-column -->
          </div><!-- end col-md-6 -->
        </div><!-- end row -->
      </div><!-- end container -->
    </div><!-- end think-fluid -->
  </section>
</template>

<script>
export default {
  name: "CPArea1",
  data() {
    return {
      img1 : "https://cdn.redgirasol.com/portal/graficos/GRAFICOS-19.png",
    }
  }
}
</script>

<style scoped>
  .custom-img {
    width: 51vh !important;
    margin-left: auto !important;
    margin-bottom: 2rem;
  }
</style>